"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerBackground = exports.DefaultBackground = exports.ConsumerBackgroundArgs = exports.BackgroundArgs = void 0;
var il_background_1 = require("./il-background");
var get_component_1 = require("../../shared/helpers/get-component");
// args
exports.BackgroundArgs = {};
exports.ConsumerBackgroundArgs = {
    childSx: {
        width: '200%',
        height: '270px',
        left: '50%',
        transform: 'translateX(-50%)',
        borderRadius: '0 0 100% 100%',
        backgroundColor: 'primary.main',
        backgroundSize: 'contain',
    },
};
// common components
exports.DefaultBackground = (0, get_component_1.getComponent)(il_background_1.ILBackground, exports.BackgroundArgs);
exports.ConsumerBackground = (0, get_component_1.getComponent)(il_background_1.ILBackground, exports.ConsumerBackgroundArgs);
